module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_activity_remoteEntry_mjs_93e15175__;